export const KEY_CODES = {
    ENTER: 'Enter',
};

export const RIGHT_SINGLE_QUOTATION_MARK = '\u2019';
export const SPECIFIC_LETTER_UNICODES = {
    à: '\u00e0',
    á: '\u00e1',
    â: '\u00e2',
    ä: '\u00e4',
    ã: '\u00e3',
    ù: '\u00f9',
    é: '\u00e9',
};

export const FILTERED_TERMS = 'filtered_terms';

export const MIN_PROJECT_NAME_LENGTH = 1;
export const MAX_PROJECT_NAME_LENGTH = 80;

export const MIN_KEYWORD_LENGTH = 2;
export const MAX_KEYWORD_LENGTH = 80;

export const MAX_CUSTOM_KEYWORD_LENGTH = 60;

export const ZERO_WIDTH_SPACES = '\u200b\u200c\u200d\u2060';
export const SPECIAL_SYMBOLS = ',;@<>*#%^!?{}\\[\\]()"«»“”„“';
export const LEAD_TRAIL_SYMBOLS = '/ \\-_\u00a0:~|\\\\&';

export const zeroWidthSpacePattern = new RegExp(`[\\s${ZERO_WIDTH_SPACES}]+`, 'g');
export const specialSymbolsCombinedPattern = new RegExp(`\\\\{2,}|/{2,}|[${SPECIAL_SYMBOLS}]`, 'g');
export const leadTrailSymbolsPattern = new RegExp(
    `^[${LEAD_TRAIL_SYMBOLS}]*|[${LEAD_TRAIL_SYMBOLS}]*$`,
    'g'
);
